var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.4163L7.5 14.1663L2.5 16.6663V5.83301L7.5 3.33301L12.5 5.83301L17.5 3.33301V9.58301",
    stroke: "#303C4A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.33301V14.1663",
    stroke: "#303C4A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.83301V10.4163",
    stroke: "#303C4A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.601 16.7675C17.9507 16.4179 18.1889 15.9725 18.2854 15.4875C18.3819 15.0025 18.3325 14.4998 18.1433 14.043C17.9541 13.5861 17.6336 13.1956 17.2225 12.9209C16.8114 12.6462 16.328 12.4995 15.8335 12.4995C15.339 12.4995 14.8556 12.6462 14.4445 12.9209C14.0334 13.1956 13.7129 13.5861 13.5237 14.043C13.3345 14.4998 13.2851 15.0025 13.3816 15.4875C13.4781 15.9725 13.7163 16.4179 14.066 16.7675C14.4143 17.1167 15.0035 17.6384 15.8335 18.3334C16.7093 17.5917 17.2993 17.07 17.601 16.7675Z",
    stroke: "#303C4A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 15V15.0079",
    stroke: "#303C4A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.c5d44474d6f9c7e2dffa4dd74fbed7c5.svg";
export { ForwardRef as ReactComponent };